<template>
  <div class="joined-community-card-list">
    <card-list v-if="hasJoinedCommunities && !hasNoFilteredResults" size="large">
      <community-list-card
        v-for="community in paginatedCommunityList"
        :key="community.id"
        :community="community"
        :subject-key="community.subjectKey"
      />
    </card-list>

    <empty-placeholder v-else-if="hasNoFilteredResults">
      <template #icon>
        <SearchEmpty />
      </template>
      <template #default>{{ t("search_result_list_no_result_message") }}</template>
    </empty-placeholder>
    <empty-placeholder v-else>
      <template #icon>
        <CommunityEmpty />
      </template>
      <template #default>
        <span>{{ t("community_group_list_no_joined_community_label") }}</span>
        <span v-if="showPlaceholderBrowseCommunityText">{{
          t("community_group_list_browse_community_navigation_button_label")
        }}</span>
      </template>
    </empty-placeholder>
  </div>
</template>

<script setup lang="ts">
import CommunityListCard from "@modules/student-group/components/CommunityListCard.vue";
import CommunityEmpty from "@images/placeholder/empty-states/CommunityEmpty.svg?component";
import SearchEmpty from "@images/placeholder/empty-states/SearchEmpty.svg?component";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

// Props
interface Props {
  hasJoinedCommunities?: boolean;
  hasNoFilteredResults?: boolean;
  paginatedCommunityList?: unknown[];
  showPlaceholderBrowseCommunityText?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  hasJoinedCommunities: false,
  hasNoFilteredResults: false,
  paginatedCommunityList: () => [],
  showPlaceholderBrowseCommunityText: true,
});
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/spacing";

.joined-community-card-list {
  width: 100%;

  .card-list {
    margin: $spacing-05 0 $spacing-06;
  }
}
</style>
